import React, { useState } from 'react';

const FALLBACK = '/assets/images/no_image.png';

function Image({
  src,
  alt = 'Image Name',
  className = '',
  fallbackIcon,
  ...props
}) {
  const [failed, setFailed] = useState(false);
  const showFallback = !src || failed;

  if (showFallback) {
    // Generate initials from alt text for a nice placeholder
    const initials = (alt || '?')
      .split(' ')
      .filter(Boolean)
      .slice(0, 2)
      .map(w => w[0]?.toUpperCase())
      .join('');

    return (
      <div
        className={`flex items-center justify-center bg-muted text-muted-foreground font-semibold select-none ${className}`}
        title={alt}
        role="img"
        aria-label={alt}
        {...props}
      >
        {initials || '?'}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={() => setFailed(true)}
      {...props}
    />
  );
}

export default Image;
